// extracted by mini-css-extract-plugin
module.exports = {"part-tab":"TeamimItem-module--part-tab--OCuW_","active-reader":"TeamimItem-module--active-reader--2ARJy","tabs-container":"TeamimItem-module--tabs-container--3cGVz"};